/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Filter_Only_OverridesInputs */



/**
* | output |
* | --- |
* | "Show only overrides" |
*
* @param {Rights_Filter_Only_OverridesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_filter_only_overrides = /** @type {((inputs?: Rights_Filter_Only_OverridesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Filter_Only_OverridesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur Überschreibungen anzeigen")
	return /** @type {LocalizedString} */ ("Show only overrides")
});